// src/App.tsx
import React from 'react';
import './App.css';
import IsingOnArbitraryLattice from './components/Working_Ising';

function App() {
  return (
    <div className="App">
      <main className="container mx-auto p-4">
        <IsingOnArbitraryLattice />
      </main>
    </div>
  );
}

export default App;